export interface PaginateRelationPageItemsOptions<T> {
	remotePageItems: T[];
	pendingCreates: T[];
	pageNumber: number;
	pageSize: number;
	remoteTotal: number;
	getKey: (item: T) => string | null;
}

/**
 * Build one page of a relation list that combines server-paginated remote rows with client-only
 * pending creates. A pending create whose target already appears among the remote rows is dropped.
 */
export function paginateRelationPageItems<T>(options: PaginateRelationPageItemsOptions<T>): T[] {
	const { remotePageItems, pendingCreates, pageNumber, pageSize, remoteTotal, getKey } = options;

	const remoteKeys = new Set(
		remotePageItems
			.map((item) => getKey(item))
			.filter((key): key is string => key !== null),
	);

	const unsavedCreates = pendingCreates.filter((item) => {
		const key = getKey(item);
		return key === null || !remoteKeys.has(key);
	});

	const pageStart = (pageNumber - 1) * pageSize;
	const pageEnd = pageStart + pageSize;
	const createsOnPage = unsavedCreates.slice(
		Math.max(0, pageStart - remoteTotal),
		Math.max(0, pageEnd - remoteTotal),
	);

	return [...remotePageItems, ...createsOnPage];
}
